import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock';

class BrixEmbed {
  static init(...parameters) {
    return new BrixEmbed(...parameters);
  }

  constructor(selector) {
    this.selector = selector;
    this.lightboxButton = this.selector.querySelector('.lightbox-button');
    this.lightbox = this.selector.querySelector('.lightbox');
    this.closeButton = this.lightbox.querySelector('.close-button');

    this.lightboxButton.addEventListener('click', () => {
      this.openLightbox();
    });

    this.closeButton.addEventListener('click', () => {
      this.lightbox.classList.remove('-is-visible');
      enableBodyScroll(this.lightbox);
    });

    const query = new URLSearchParams(window.location.search);
    const openLightbox = query.get('openlightbox');
    if (openLightbox) {
      disableBodyScroll(this.lightbox);
      this.lightbox.classList.add('-is-visible');
    }
  }

  openLightbox() {
    disableBodyScroll(this.lightbox);
    this.lightbox.classList.add('-is-visible');
  }
}

// Register class
if (window.brix && window.brix.registerBlock) {
  window.brix.registerBlock('brix-embed', BrixEmbed.init);
}
